var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosCss3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 70,
    viewBox: "0 0 50 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7897 69.8231L4.58825 64.215L0.0863342 13.7219H49.5536L45.0471 64.2072L24.7897 69.8231Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.189 60.9924L45.0399 17.8503H24.82V65.5304L41.189 60.9924Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4068 36.5776L10.9617 42.7704H24.82V36.5776H10.4068ZM9.29144 24.0433L9.85435 30.2361H24.82V24.0433H9.29144ZM24.82 52.6609L24.7929 52.6681L17.896 50.8058L17.4551 45.8669H11.2385L12.106 55.5905L24.7915 59.1118L24.82 59.104V52.6609Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7282 0H19.2285V3.13662H14.8649V6.27324H19.2289V9.40967H11.7282V0ZM20.7288 0H28.2292V2.72748H23.8654V3.27294H28.2292V9.54618H20.729V6.68199H25.0928V6.13654H20.7286V0H20.7288ZM29.7295 0H37.23V2.72748H32.8661V3.27294H37.23V9.54618H29.7295V6.68199H34.0933V6.13654H29.7297V0H29.7295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1936 36.5776L40.3115 24.0433H24.7987V30.2361H33.5248L32.9613 36.5776H24.7987V42.7704H32.4244L31.7054 50.802L24.7985 52.6662V59.1089L37.4941 55.5905L37.5871 54.5441L39.0426 38.2405L39.1936 36.5776Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.64,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosCss3);
export default __webpack_public_path__ + "static/media/logos_css-3.bf1207a2e1545b5ac00595efbc6ab353.svg";
export { ForwardRef as ReactComponent };